export const ROLES = {
  BOOK_KEEPER: 'Bookkeeper',
  OWNER: 'Owner',
  MANAGER: 'Manager',
};
